import { Component, Host, h, Prop } from '@stencil/core';
export class Col {
  render() {
    return (h(Host, null,
      h("slot", null)));
  }
  static get is() { return "sy-col"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["scss/index.scss", "scss/_tokens.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["./scss/index.css", "./scss/_tokens.css"]
  }; }
  static get properties() { return {
    "size": {
      "type": "any",
      "mutable": false,
      "complexType": {
        "original": "number | 'auto'",
        "resolved": "\"auto\" | number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines how many of the 12 available columns of the row will be occupied in all screens. Must be a value between 1 and 12, both included. If set to `auto`,\nit will use the remaining space available."
      },
      "attribute": "size",
      "reflect": true
    },
    "sizeSm": {
      "type": "any",
      "mutable": false,
      "complexType": {
        "original": "number | 'auto'",
        "resolved": "\"auto\" | number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines how many of the 12 available columns of the row will be occupied in small screens. Must be a value between 1 and 12, both included. If set to `auto`,\nit will use the remaining space available."
      },
      "attribute": "size-sm",
      "reflect": true
    },
    "sizeMd": {
      "type": "any",
      "mutable": false,
      "complexType": {
        "original": "number | 'auto'",
        "resolved": "\"auto\" | number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines how many of the 12 available columns of the row will be occupied in medium screens. Must be a value between 1 and 12, both included. If set to `auto`,\nit will use the remaining space available."
      },
      "attribute": "size-md",
      "reflect": true
    },
    "sizeLg": {
      "type": "any",
      "mutable": false,
      "complexType": {
        "original": "number | 'auto'",
        "resolved": "\"auto\" | number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines how many of the 12 available columns of the row will be occupied in large screens. Must be a value between 1 and 12, both included. If set to `auto`,\nit will use the remaining space available."
      },
      "attribute": "size-lg",
      "reflect": true
    },
    "sizeXl": {
      "type": "any",
      "mutable": false,
      "complexType": {
        "original": "number | 'auto'",
        "resolved": "\"auto\" | number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines how many of the 12 available columns of the row will be occupied in extra large screens. Must be a value between 1 and 12, both included. If set to `auto`,\nit will use the remaining space available."
      },
      "attribute": "size-xl",
      "reflect": true
    },
    "sizeXxl": {
      "type": "any",
      "mutable": false,
      "complexType": {
        "original": "number | 'auto'",
        "resolved": "\"auto\" | number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines how many of the 12 available columns of the row will be occupied in extra extra large screens. Must be a value between 1 and 12, both included. If set to `auto`,\nit will use the remaining space available."
      },
      "attribute": "size-xxl",
      "reflect": true
    },
    "offset": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines how many columns the element will shift to the end in all screens. Must be a value between 1 and 12, both included."
      },
      "attribute": "offset",
      "reflect": true
    },
    "offsetSm": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines how many columns the element will shift to the end in small screens. Must be a value between 1 and 12, both included."
      },
      "attribute": "offset-sm",
      "reflect": true
    },
    "offsetMd": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines how many columns the element will shift to the end in medium screens. Must be a value between 1 and 12, both included."
      },
      "attribute": "offset-md",
      "reflect": true
    },
    "offsetLg": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines how many columns the element will shift to the end in large screens. Must be a value between 1 and 12, both included."
      },
      "attribute": "offset-lg",
      "reflect": true
    },
    "offsetXl": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines how many columns the element will shift to the end in extra large screens. Must be a value between 1 and 12, both included."
      },
      "attribute": "offset-xl",
      "reflect": true
    },
    "offsetXxl": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines how many columns the element will shift to the end in extra extra large screens. Must be a value between 1 and 12, both included."
      },
      "attribute": "offset-xxl",
      "reflect": true
    },
    "order": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the order of the column in all screens. Must be a value between 1 and 12, both included."
      },
      "attribute": "order",
      "reflect": true
    },
    "orderSm": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the order of the column in small screens. Must be a value between 1 and 12, both included."
      },
      "attribute": "order-sm",
      "reflect": true
    },
    "orderMd": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the order of the column in medium screens. Must be a value between 1 and 12, both included."
      },
      "attribute": "order-md",
      "reflect": true
    },
    "orderLg": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the order of the column in large screens. Must be a value between 1 and 12, both included."
      },
      "attribute": "order-lg",
      "reflect": true
    },
    "orderXl": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the order of the column in extra large screens. Must be a value between 1 and 12, both included."
      },
      "attribute": "order-xl",
      "reflect": true
    },
    "orderXxl": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the order of the column in extra extra large screens. Must be a value between 1 and 12, both included."
      },
      "attribute": "order-xxl",
      "reflect": true
    }
  }; }
}
